// LICENSE_CODE ZON
'use strict'; /*jslint react:true*/
import React, {useCallback, useMemo} from 'react';
import cn from 'classnames';
import debounce from 'lodash4/debounce.js';
import {Text} from '../../comp/text';
import {Dropdown} from '../../comp/dropdown';
import {Button} from '../../comp/button';
import {Checkbox} from '../../comp/checkbox';
import {Text_input} from '../../comp/text_input';
import {SORT_ITEMS, OS_FILTERS, DEBOUNCE_MS, SORTING_KEY, SEARCH_KEY,
    OS_KEY} from './constants.js';
import * as cns from './filter.module.less';

function Search({on_change, disabled}){
    return <div className={cns.search_container}>
      <Text.s span className={cns.mobile_only} tertiary>Search</Text.s>
      <Text_input className={cns.search} placeholder="Search"
        on_change={on_change} size="s" ico_left="search" disabled={disabled}/>
    </div>;
}

function Sort_button({value, on_change, disabled}){
    return <div className={cns.sort_container}>
      <Text.s span tertiary>Sort by</Text.s>
      <Dropdown className={cns.sort} items={SORT_ITEMS} value={value}
        on_change={on_change} size="s" disabled={disabled}/>
    </div>;
}

function Os_filter({value, on_change, data, disabled}){
    const handle_change = useCallback(v=>
        on_change(data.id, v), [on_change, data.id]);
    return <Checkbox ico={data.ico} label={data.title} checked={value}
      on_change={handle_change} disabled={disabled}/>;
}

export function Filter({className, value, on_change, mob_open, disabled}){
    const handle_sort_change = useCallback(v=>
        on_change(SORTING_KEY, v), [on_change]);
    const handle_search_change_debounced = useMemo(()=>
        debounce(v=>on_change(SEARCH_KEY, v), DEBOUNCE_MS, {trailing: true}),
        [on_change]);
    const handle_os_change = useCallback((id, v)=>{
        const cur_val = value[OS_KEY];
        let new_val = v ? [...cur_val, id] : cur_val.filter(vv=>vv!=id);
        if (!new_val.length)
            new_val = OS_FILTERS.map(f=>f.id);
        on_change(OS_KEY, new_val);
    }, [value, on_change]);
    return <div className={cn(cns.filter, !mob_open&&cns.filter__closed,
      className)}>
      <div className={cns.os_container}>
        <Text.s span className={cns.mobile_only} tertiary>
          Choose <br/>Devices
        </Text.s>
        <ul className={cns.os_list}>
          {OS_FILTERS.map(item=><li key={item.id}>
            <Os_filter data={item} value={value[OS_KEY].includes(item.id)}
              on_change={handle_os_change} disabled={disabled}/>
          </li>)}
        </ul>
      </div>
      <Search on_change={handle_search_change_debounced}/>
      <Sort_button value={value[SORTING_KEY]} on_change={handle_sort_change}
        disabled={disabled}/>
    </div>;
}

export function Mobile_toggle({value, on_change}){
    const label = value ? 'Close' : 'Filter';
    const icon = value ? 'close' : 'filter';
    const toggle_filter = useCallback(()=>
        on_change?.(!value), [on_change, value]);
    return <Button className={cns.mobile_toggle} ico={icon} filled
      on_click={toggle_filter} round size="s" color_scheme="tertiary">
      {label}
    </Button>;
}
